import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Store, Package, MapPin, ShoppingCart, QrCode, Star, Mail } from "lucide-react";
import api, { money } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Admin() {
  const { user, checking } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)).catch(() => {}); }, []);

  if (checking || user === null) return <div className="min-h-screen grid place-items-center text-stone-400">Loading…</div>;
  if (!user || user.role !== "admin") return <div className="min-h-[60vh] grid place-items-center text-stone-500">Admin access required. <Link to="/login" className="ml-2 font-bold text-[var(--friib)]">Sign in</Link></div>;
  if (!d) return <div className="min-h-[60vh] grid place-items-center text-stone-400">Loading overview…</div>;

  const stats = [
    ["Users", d.users, Users], ["Shoppers", d.shoppers, Users], ["Merchants", d.merchants, Store],
    ["Products", d.products, Package], ["Local Offers", d.local_offers, MapPin], ["Orders", d.orders, ShoppingCart],
    ["Passes", d.passes, QrCode], ["Reviews", d.reviews, Star], ["Newsletter", d.newsletter, Mail],
  ];
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-display text-3xl lg:text-4xl font-extrabold text-stone-900 mb-1">Friib Admin</h1>
      <p className="text-stone-500 mb-8">Platform overview & moderation.</p>
      <div className="grid grid-cols-3 lg:grid-cols-5 gap-4 mb-10">
        {stats.map(([l, v, Icon]) => (
          <div key={l} className="rounded-2xl bg-white border border-stone-100 friib-shadow p-5" data-testid={`admin-stat-${l.toLowerCase()}`}>
            <Icon size={18} className="text-stone-400 mb-2" />
            <p className="font-display text-2xl font-extrabold text-stone-900">{v}</p>
            <p className="text-xs font-semibold text-stone-500">{l}</p>
          </div>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="rounded-2xl bg-white border border-stone-100 friib-shadow p-5">
          <h3 className="font-display font-bold text-stone-900 mb-3">Recent orders</h3>
          <div className="space-y-2">
            {d.recent_orders.map((o) => <div key={o.id} className="flex justify-between text-sm border-b border-stone-50 py-2"><span className="text-stone-700">{o.product_name} · {o.customer_name}</span><span className="font-semibold">{money(o.total)}</span></div>)}
            {d.recent_orders.length === 0 && <p className="text-stone-400 text-sm">No orders yet.</p>}
          </div>
        </div>
        <div className="rounded-2xl bg-white border border-stone-100 friib-shadow p-5">
          <h3 className="font-display font-bold text-stone-900 mb-3">Recent users</h3>
          <div className="space-y-2">
            {d.recent_users.map((u, i) => <div key={i} className="flex justify-between text-sm border-b border-stone-50 py-2"><span className="text-stone-700">{u.name} · {u.email}</span><span className="px-2 py-0.5 rounded-full text-xs font-bold bg-stone-100 capitalize">{u.role}</span></div>)}
          </div>
        </div>
      </div>
    </div>
  );
}
